import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { CML } from 'bundles/cml';
import AdminDetails from 'bundles/discussions/components/AdminDetails';
import Badge from 'bundles/discussions/components/Badge';
import CreatedTimeLink from 'bundles/discussions/components/CreatedTimeLink';
import EditIndicator from 'bundles/discussions/components/EditIndicator';
import Follow from 'bundles/discussions/components/Follow';
import ModerationDropdown from 'bundles/discussions/components/ModerationDropdown';
import NextViewLink from 'bundles/discussions/components/NextViewLink';
import ProfileName from 'bundles/discussions/components/ProfileName';
import ReplyButton from 'bundles/discussions/components/ReplyButton';
import Upvote from 'bundles/discussions/components/Upvote';
import ProfileArea from 'bundles/discussions/components/profiles/ProfileArea';
import { formatReplyLegendId } from 'bundles/discussions/utils/threadUtils';
import FlexSupportExperiments from 'bundles/epic/clients/FlexSupport';

import _t from 'i18n!nls/discussions';

import 'css!bundles/discussions/components/discussionsBody/__styles__/DetailedQuestion';

class DetailedQuestion extends React.Component {
  static propTypes = {
    goToInput: PropTypes.func.isRequired,
    question: PropTypes.object,
    isPinned: PropTypes.bool,
    forumLink: PropTypes.string,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof DetailedQuestion.contextTypes>;

  onDeleteSuccess = (reason: $TSFixMe) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumLink' does not exist on type 'Reado... Remove this comment to see the full error message
    const { forumLink } = this.props;
    if (!reason) {
      this.context.router.replace(forumLink);
    }
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    const { question, forumLink, isPinned, goToInput } = this.props;
    if (!question) return null;
    const isFlagged = (question.flagDetails && question.flagDetails.isActive) || question.isFlagged;
    const questionClasses = classNames('headline-3-text question-header', { flagged: isFlagged });
    const detailsClasses = classNames({ flagged: isFlagged });
    const { creator } = question;
    const replyLegendId = formatReplyLegendId(question);
    const isCustomLabelsEnabled = FlexSupportExperiments.get('customLabelsEnabled', { course_id: question.courseId });

    return (
      <div className="rc-DetailedQuestion card-rich-interaction horizontal-box">
        <div id={replyLegendId} className="screenreader-only pii-hide">
          <FormattedMessage message={_t("{name}'s Post")} name={creator?.fullName} />
        </div>
        <div className="profile">
          <ProfileArea
            courseRole={creator?.courseRole}
            externalUserId={creator?.externalUserId}
            fullName={creator?.fullName}
            helperStatus={creator?.helperStatus}
            profileImageUrl={creator?.isDefaultPhoto ? '' : creator?.photoUrl || ''}
          />
        </div>
        <div className="flex-1">
          <div className="horizontal-box">
            <h3 className={questionClasses}>{question.content.question}</h3>
            {isPinned && <i className="cif-pin cif-lg pin" />}
          </div>
          <div className="metadata caption-text color-secondary-text">
            <ProfileName fullName={creator?.fullName} externalId={creator?.externalUserId} ariaHidden={true} />
            <Badge creator={creator} />
            {!isCustomLabelsEnabled && <NextViewLink question={question} />}
            <span>&nbsp;·&nbsp;</span>
            <CreatedTimeLink post={question} forumLink={forumLink} />
            <EditIndicator post={question} />
          </div>
          <div className={detailsClasses}>
            <CML cml={question.content.details} className={detailsClasses} />
          </div>
          <div className="action-area horizontal-box align-items-vertical-center caption-text color-secondary-text">
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ post: any; }' is not assignable to type 'I... Remove this comment to see the full error message */}
            <Upvote post={question} />
            <ReplyButton handleClick={goToInput} text={_t('Reply')} creator={creator} />
            <Follow question={question} />
          </div>
        </div>
        <AdminDetails post={question} />
        <ModerationDropdown
          onDeleteSuccess={this.onDeleteSuccess}
          creator={creator}
          post={question}
          forumLink={forumLink}
          ariaDescribedBy={replyLegendId}
        />
      </div>
    );
  }
}

export default DetailedQuestion;
